// API configuration
const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:8001' 
  : '/api';

export { API_BASE_URL }; 